module.exports = __webpack_public_path__ + "static/img/default_avatar.47964cc3.png";